module.exports = __webpack_public_path__ + "img/brand-cases10.c3dac19b.png";